import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import Dialog from "@mui/material/Dialog";
import Drawer from "@mui/material/Drawer";
import { makeStyles } from "@mui/styles";
import { Button } from "@mui/material";
import Rating from "@mui/material/Rating";
//styles
import { toast } from "react-toastify";
// import { useRightDrawerStyles } from "../../../../custom-hooks/useDrawerStyles";

import profileIcon from "../../../../../assets/img/icons/profile.png";
import messagesIcon from "../../../../../assets/img/icons/bell.png";
import ordersIcon from "../../../../../assets/img/icons/orders.png";
import bargainingIcon from "../../../../../assets/img/icons/bargaining.png";
import festivalIcon from "../../../../../assets/img/icons/festival.png";
import supportIcon from "../../../../../assets/img/icons/support.png";
import productsIcon from "../../../../../assets/img/icons/products.png";
import exitIcon from "../../../../../assets/img/icons/exit.png";
import palleteIcon from "../../../../../assets/img/icons/color-palette.png";
import tolidiProductIcon from "../../../../../assets/img/icons/tolidi-product-1.png";

import { useRightDrawerStyles } from "../../../../../core/custom-hooks/useDrawerStyles";
import "./styles/styles.scss";
import { ExitToApp } from "@mui/icons-material";
// import { useAuthenticationActions } from "../../../../../core/contexts/authentication/authenticationProvider";
import CachedIcon from "@mui/icons-material/Cached";
import colors from "../../../../../assets/styles/variables/_colors.module.scss";
import { deleteAllCookies } from "../../../../../core/utils/deleteCookies";
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "../../../../../core/redux/actions/userAuthActions";

const tabItems = [
  { id: 0, link: "/profile", title: "پروفایل", tabIcon: profileIcon },
  { id: 1, link: "/pallete", title: "کالیته ها", tabIcon: palleteIcon },
  { id: 2, link: "/products", title: "محصولات", tabIcon: productsIcon },
  { id: 3, link: "/orders", title: "سفارشات", tabIcon: ordersIcon },
  { id: 4, link: "/bargaining", title: "چانه زنی ها", tabIcon: bargainingIcon },
];

const Aside = (props) => {
  const rightDrawerClasses = useRightDrawerStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileData } = useSelector((state) => state.userProfileReducer);

  const logout = () => {
    dispatch(logoutAction());
    window.location.href = "/";
  };

  const handleNav = (e) => {
    props?.onClose();
  };

  useEffect(() => {
    props?.onClose();
  }, [window.location.pathname]);

  const handleFullReloadApp = () => {
    if ("serviceWorker" in navigator) {
      caches.keys().then(function (cacheNames) {
        cacheNames.forEach(function (cacheName) {
          caches.delete(cacheName);
        });
      });
    }
    deleteAllCookies();
    window.location.href = "/";
  };

  return (
    <Drawer
      // keepMounted
      classes={rightDrawerClasses}
      dir="rtl"
      anchor="right"
      {...props}
    >
      <div className="aside h-100 m-0 p-3 d-flex flex-column justify-content-between align-items-stretch">
        <div className="my-3 mx-3 d-flex flex-column justify-content-between align-items-stretch">
          {tabItems.map((item, index) => (
            <Link
              to={item.link}
              // onMouseDown={handleNav}
              className="m-0 my-3 tab-item p-0 d-flex flex-row justify-content-start align-items-center text-decoration-none"
              key={item.id}
            >
              <img
                className={(index === 1 || index === 2 ? "" : "") + " me-2"}
                alt={item.title}
                src={item.tabIcon}
                style={{ maxWidth: "20px" }}
              />
              {item.title}
            </Link>
          ))}
        </div>
        {/* isFrushgah */}
        {profileData?.isFrushgah === true && (
          <Link
            to={"/producersProducts"}
            className="m-0 tab-item pt-0 p-3 d-flex flex-row justify-content-start align-items-center text-decoration-none"
          >
            <img
              className={"  me-2"}
              alt={"..."}
              src={tolidiProductIcon}
              style={{ maxWidth: "25px" }}
            />
            محصولات تولیدی ها
          </Link>
        )}
        {/* <div
          onClick={handleFullReloadApp}
          className="cursor-pointer align-self-start flex-row mx-3 p-2 mb-2 mt-auto justify-content-start align-items-center"
        >
          <CachedIcon
            className="me-2"
            htmlColor="#fff"
            sx={{ fontSize: "30px" }}
          />
          <span className="text-white ">به روز رسانی اپلیکیشن</span>
        </div> */}
        <div
          onClick={logout}
          className="cursor-pointer align-self-start flex-row mx-3 p-2 mb-3 mt-auto justify-content-start align-items-center"
        >
          <ExitToApp
            className="me-2"
            htmlColor={colors["main-color-2-contrast"]}
          />
          <span className="text-white ">خروج</span>
        </div>
      </div>
    </Drawer>
  );
};

export default Aside;
